// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tag-scroll {
  font-family: Montserrat-Regular, sans-serif;
  font-size: 14px;
  overflow: hidden;
  white-space: nowrap;
  position: relative;
  color: #444444;
  opacity: 0;
  transition: opacity cubic-bezier(0.215, 0.61, 0.355, 1) 0.3s;
  width: 100%;
}
.tag-scroll .tag-scroll-body {
  position: relative;
  left: 0;
  transition: left cubic-bezier(0.215, 0.61, 0.355, 1) 1s, right cubic-bezier(0.215, 0.61, 0.355, 1) 1s;
  max-height: 30px;
}
.tag-scroll .tag-scroll-body .pill-container {
  display: inline-block;
}
.tag-scroll .tag-scroll-body .pill-container .pill {
  transition: border-color cubic-bezier(0.215, 0.61, 0.355, 1) 0.2s;
  background-color: #7F6C2E;
  padding: 4px 8px 4px 8px;
  margin: 0 6px 5px 0;
  opacity: 1;
  font-family: Montserrat-Light, sans-serif;
  font-size: 15px;
  color: white;
}
.tag-scroll .tag-scroll-body .pill-container .pill .remove {
  display: inline-block;
  background-image: url('dropdown-x.d3c3408902547efd.svg');
  background-size: cover;
  width: 15px;
  height: 15px;
  margin-left: 5px;
  margin-top: 1px;
  vertical-align: middle;
  margin-bottom: 2px;
}
.tag-scroll .tag-scroll-body .pill-container .pill .remove:hover {
  cursor: pointer;
}
.tag-scroll .tag-scroll-body .pill-container:last-child {
  margin-right: 65px;
}
.tag-scroll .scroll {
  height: 80px;
  width: 80px;
  position: absolute;
  top: 0;
  z-index: 1;
  background-repeat: no-repeat;
  background-image: url('closed-chev.48b8b36abe2e3166.svg'), linear-gradient(rgba(255, 0, 0, 0), white 50%);
  transition: opacity cubic-bezier(0.215, 0.61, 0.355, 1) 0.3s;
  opacity: 0;
}
.tag-scroll .scroll.left {
  left: -20px;
  transform: rotate(90deg);
  background-position: 5% 70%;
}
.tag-scroll .scroll.right {
  right: -20px;
  transform: rotate(-90deg);
  background-position: 95% 70%;
}
.tag-scroll .scroll.visible {
  opacity: 1;
  transition: opacity cubic-bezier(0.215, 0.61, 0.355, 1) 0.3s;
}
.tag-scroll .scroll.visible:hover {
  cursor: pointer;
}
.tag-scroll .scroll.hidden {
  display: none;
}
.tag-scroll.visible {
  transition: opacity cubic-bezier(0.215, 0.61, 0.355, 1) 0.3s;
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./node_modules/proceduralsystem-clientcomponents/components/tag-scroll/tag-scroll.component.less"],"names":[],"mappings":"AAEA;EACE,2CAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;EACA,4DAAA;EACA,WAAA;AADF;AARA;EAYI,kBAAA;EACA,OAAA;EACA,qGAAA;EACA,gBAAA;AADJ;AAdA;EAkBM,qBAAA;AADN;AAjBA;EAqBQ,iEAAA;EACA,yBAAA;EACA,wBAAA;EACA,mBAAA;EACA,UAAA;EACA,yCAAA;EACA,eAAA;EACA,YAAA;AADR;AA3BA;EA+BU,qBAAA;EACA,wDAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;AADV;AAGU;EACA,eAAA;AADV;AAMM;EACE,kBAAA;AAJR;AA5CA;EAsDM,YAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,4BAAA;EACA,yGAAA;EACA,4DAAA;EACA,UAAA;AAPN;AASM;EACE,WAAA;EACA,wBAAA;EACA,2BAAA;AAPR;AAUM;EACE,YAAA;EACA,yBAAA;EACA,4BAAA;AARR;AAWM;EACE,UAAA;EACA,4DAAA;AATR;AAWQ;EACE,eAAA;AATV;AAaM;EACE,aAAA;AAXR;AAgBI;EACE,4DAAA;EACA,UAAA;AAdN","sourcesContent":["@import (reference) \"../../styles/variables.less\";;\n\n.tag-scroll {\n  font-family: Montserrat-Regular, sans-serif;\n  font-size: 14px;\n  overflow: hidden;\n  white-space: nowrap;\n  position: relative;\n  color: @secondary-90;\n  opacity: 0;\n  transition: opacity cubic-bezier(.215,.61,.355,1) .3s;\n  width: 100%;\n\n  .tag-scroll-body {\n    position: relative;\n    left: 0;\n    transition: left cubic-bezier(.215,.61,.355,1) 1s, right cubic-bezier(.215,.61,.355,1) 1s;\n    max-height: 30px;\n\n    .pill-container {\n      display: inline-block;\n\n      .pill {\n        transition: border-color cubic-bezier(.215,.61,.355,1) .2s;\n        background-color: @primary-base;\n        padding: 4px 8px 4px 8px;\n        margin: 0 6px 5px 0;\n        opacity: 1;\n        font-family: Montserrat-Light, sans-serif;\n        font-size: 15px;\n        color: white;\n\n        .remove {\n          display: inline-block;\n          background-image: url('../../styles/img/dropdown-x.svg');\n          background-size: cover;\n          width: 15px;\n          height: 15px;\n          margin-left: 5px;\n          margin-top: 1px;\n          vertical-align: middle;\n          margin-bottom: 2px;\n\n          &:hover {\n          cursor: pointer;\n          }\n        }\n      }\n\n      &:last-child {\n        margin-right: 65px;\n      }\n    }\n  }\n\n  .scroll {\n      height: 80px;\n      width: 80px;\n      position: absolute;\n      top: 0;\n      z-index: 1;\n      background-repeat: no-repeat;\n      background-image: url(../../styles/img/closed-chev.svg), linear-gradient(rgba(255,0,0,0), white 50%);\n      transition: opacity cubic-bezier(.215,.61,.355,1) .3s;\n      opacity: 0;\n\n      &.left {\n        left: -20px;\n        transform: rotate(90deg);\n        background-position: 5% 70%;\n      }\n\n      &.right {\n        right: -20px;\n        transform: rotate(-90deg);\n        background-position: 95% 70%;\n      }\n\n      &.visible {\n        opacity: 1;\n        transition: opacity cubic-bezier(.215,.61,.355,1) .3s;\n\n        &:hover {\n          cursor: pointer;\n        }\n      }\n\n      &.hidden {\n        display: none;\n      }\n    }\n\n\n    &.visible {\n      transition: opacity cubic-bezier(.215,.61,.355,1) .3s;\n      opacity: 1;\n    }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
